import React from 'react'
import { get } from 'lodash'
import { CapacityForm } from './steps/Capacity'
import { AbilityForm } from './steps/Ability'
import { LpaForm } from './steps/Lpa'
import { WitnessForm } from './steps/Witness'
import { SignatureForm } from './steps/Signature'
import { ConfirmStep } from './steps/Confirm'
import FormStateType from '../FormState.type'
import Success from './steps/Success'
import { Resident } from '@lmc/ts-common'
import { MentalCapacityToConsent } from '@lmc/validations'
import StartClean from './steps/StartClean'

type SignatureModalBodyTypes = {
  isDesktop: boolean
  currentStep: string
  confirmText: string
  formState: FormStateType
  resident: Resident
  setFormState: (formState: object) => void
  goToNext: (step: string) => void
  isGP?: boolean
  mentalCapacityStatus?: MentalCapacityToConsent
}

export function SignatureModalBody({
  isDesktop,
  confirmText,
  currentStep,
  formState,
  resident,
  setFormState,
  goToNext,
  isGP,
  mentalCapacityStatus,
}: SignatureModalBodyTypes) {
  const name = resident?.preferredName || get(resident, 'name.first') || ''
  const onComplete = (fields: any) => {
    setFormState({ ...formState, ...fields })
  }

  if (currentStep === 'start') {
    return (
      <CapacityForm
        value={formState.capacity}
        name={name}
        mentalCapacityStatus={mentalCapacityStatus}
        onComplete={(capacity: boolean) => {
          onComplete({ capacity })
          if (!isDesktop) {
            if (capacity) goToNext('ability')
            else goToNext('lpa')
          }
        }}
      />
    )
  }

  if (currentStep === 'ability') {
    return (
      <AbilityForm
        name={name}
        value={formState.ability}
        onComplete={(ability) => {
          onComplete({ ability })
          if (!isDesktop) {
            if (ability) goToNext('sign')
            else goToNext('witness')
          }
        }}
      />
    )
  }

  if (currentStep === 'lpa') {
    return (
      <LpaForm
        name={name}
        // @ts-ignore
        value={formState.lpaValue}
        // @ts-ignore
        importantContacts={resident.importantContacts}
        onComplete={(lpa) => {
          // name & relationship
          onComplete(lpa)
          if (!isDesktop) {
            if (lpa.name) goToNext('sign')
            else goToNext('witness')
          }
        }}
      />
    )
  }

  if (currentStep === 'witness') {
    return (
      <WitnessForm
        name={name}
        formState={formState}
        setFormState={onComplete}
      />
    )
  }

  if (currentStep === 'sign') {
    return (
      <SignatureForm
        formState={formState}
        confirmText={confirmText}
        setFormState={onComplete}
      />
    )
  }

  if (currentStep === 'confirm') {
    return (
      <ConfirmStep
        resident={resident}
        formState={formState}
        setFormState={onComplete}
      />
    )
  }

  if (currentStep === 'start-clean') {
    return <StartClean />
  }

  if (currentStep === 'success') {
    return <Success isGP={isGP} />
  }
}

export default SignatureModalBody
